// extracted by mini-css-extract-plugin
export default {"V2FormTimePicker":"V2FormTimePicker--tdZJD","markerAnimationScale":"markerAnimationScale--yP8X5"};